export const CREATE_PROPERTY_DOCUMENT = "CREATE_PROPERTY_DOCUMENT";
export const FETCH_PROPERTY_DOCUMENTS = "FETCH_PROPERTY_DOCUMENTS";
export const FETCH_PROPERTY_DOCUMENT = "FETCH_PROPERTY_DOCUMENT";
export const EDIT_PROPERTY_DOCUMENT = "EDIT_PROPERTY_DOCUMENT";
export const DELETE_PROPERTY_DOCUMENT = "DELETE_PROPERTY_DOCUMENT";
